import MaterialTable from "material-table";
import { defaultGridOptions, tooltipDelay, useGridColDefs } from "../../utils/GridUtils";
import CancelIcon from "@material-ui/icons/Cancel";
import { Button, makeStyles, Tooltip } from "@material-ui/core";
import { centeredCell } from "../../constants/StyleConstants";
import { useContext, useEffect, useState } from "react";
import { LoginContext } from "../../contexts/LoginContext";
import { Fragment } from "react";
import MaterialsRequiresConfirmationDialog from "./MaterialsRequiresConfirmationDialog";
import CertificateExclusionSupplierDialog from "../../screens/MaterialsRequires/QualityCertificateExclusion/CertificateExclusionSupplierDialog";
import { AddBox, ListAlt } from "@material-ui/icons";
import CertificateExclusionPurchaseOrdersDialog from "../../screens/MaterialsRequires/QualityCertificateExclusion/CertificateExclusionPurchaseOrdersDialog";
import MaterialRequiresAddModal from "./MaterialRequiresAddModal";

import PersonIcon from "@mui/icons-material/Person";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import ActivityLogs from "./MaterialActivityLogs/ActivityLogsDialog";
import { SOURCETYPES } from "../../constants/GlobalConstants";

const useStyles = makeStyles(theme => ({
  centeredCell,
  root: {
    marginTop: "3em",
  },
  gridActions: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginBottom: "1em",
  },
  gridControls: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  gridButtonsWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "1em",
  },
  gridReference: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    columnGap: "1em",
    fontSize: ".8em",
  },
  reference: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  leftSideButton: {
    borderRadius: "1em",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  rightSideButton: {
    borderRadius: "1em",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  activeGlow: {
    color: "rgb(0, 255, 0)",
    boxShadow: "0px 0px 10px 0px rgb(0, 255, 0, .5)",
    borderRadius: "50%",
    margin: 0,
    stroke: "rgb(0, 255, 0, .5)",
    strokeWidth: 4,
    strokeOpacity: 0.7,
  },
  hasNoComments: {
    color: "#BDBDBD",
  },
  sortButton: {
    "&.MuiButton-root": {
      minWidth: "unset",
    },
    "&.MuiButton-startIcon": {
      margin: 0,
    },
  },
}));

const GridActions = ({
  selectedRows,
  setOpen,
  loadingChangeRequires,
  sort,
  setSort,
  setOpenExclusion,
  setOpenExclusionOrder,

  openAdd,
  setOpenAdd,

  ...restProps
}) => {
  const classes = useStyles();
  const { isAllowedByRole } = useContext(LoginContext);

  const handleCheckIn = () => {
    setOpen(true);
  };

  return (
    <div className={classes.gridControls}>
      <div className={classes.gridButtonsWrapper}>
        <Tooltip
          placement="top"
          arrow
          title={
            selectedRows.isEmpty()
              ? "Seleccione al menos un material a eliminar"
              : ""
          }
        >
          <div>
            <Button
              disabled={selectedRows.isEmpty()}
              variant="contained"
              color="secondary"
              size="small"
              startIcon={<CancelIcon />}
              onClick={() => isAllowedByRole() && handleCheckIn()}
            >
              Eliminar material
            </Button>
          </div>
        </Tooltip>

        <MaterialRequiresAddModal openAdd={openAdd} setOpenAdd={setOpenAdd} />
        <Button
          variant="contained"
          color="primary"
          size="small"
          //className={classes.actionHeaderButton}
          startIcon={<AddBox />}
          onClick={() => setOpenAdd(true)}
        >
          Añadir material
        </Button>
      </div>
    </div>
  );
};

const MaterialsRequiresGrid = ({
  data,
  loading,
  tableRef,
  reloadGrid,
  selectedRows,
  setSelectedRows,
  open,
  setOpen,
  openExclusion,
  setOpenExclusion,
  openExclusionOrder,
  setOpenExclusionOrder,
  openAdd,
  setOpenAdd,
  openActivity,
  setOpenActivity,
  gridActions,
}) => {
  const classes = useStyles();

  const BoldValue = ({ value }) => {
    return <b>{value}</b>;
  };

  const colDefs = useGridColDefs([
    {
      title: "Código Material",
      field: "code",
      valueRender: (value) => value.replace(/^0+/, ""),
    },
    {
      title: "Nombre Material",
      field: "name",
      valueRender: (value, rowData) => <BoldValue value={value} />,
    },
  ]);

  return (
    <Fragment>

      <MaterialsRequiresConfirmationDialog
        open={open}
        setOpen={setOpen}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        reloadGrid={reloadGrid}
      />

      <MaterialRequiresAddModal
        openAdd={openAdd}
        setOpenAdd={setOpenAdd}
        reloadGrid={reloadGrid}
      />

      <div className={classes.root}>
        <div className={classes.gridActions}>
          {
            <GridActions
              selectedRows={selectedRows}
              loading={loading}
              setOpen={setOpen}
              setOpenExclusion={setOpenExclusion}
              setOpenExclusionOrder={setOpenExclusionOrder}
              setOpenAdd={setOpenAdd}
              {...gridActions}
            />
          }
        </div>
        <MaterialTable
          {...defaultGridOptions}
          options={{
            ...defaultGridOptions.options,
            pageSizeOptions: [
              ...defaultGridOptions.options.pageSizeOptions,
              defaultGridOptions.options.pageSizeOptions.last() * 2,
            ],
            selection: true,
            headerSelectionProps: { color: "primary" },
            selectionProps: (rowData) => {
              return {
                color: "primary",
              };
            },
          }}
          onSelectionChange={(rows, row) => setSelectedRows(rows)}
          columns={colDefs}
          data={data}
          isLoading={loading}
          tableRef={tableRef}
        />
      </div>

      <Button
        variant="contained"
        color="primary"
        style={{ marginTop: "10px" }}
        size="small"
        onClick={() => setOpenActivity(true)}
        startIcon={<ListAlt />}
      >
        Registro de actividades
      </Button>
      <ActivityLogs open={openActivity} setOpen={setOpenActivity} sourceType={SOURCETYPES.MATERIAL_REQUIRES}/>
    </Fragment>
  );
};

export default MaterialsRequiresGrid;
